import { FC } from 'react';

import { GiftCouponSummary } from '@shared/api/giftCoupon/giftCoupon.interface';

interface DisposeSectionProps {
  disposeMode: boolean;
  setDisposeMode: (v: boolean) => void;
  disposeAction: 'dispose' | 'dispose-reissue';
  setDisposeAction: (v: 'dispose' | 'dispose-reissue') => void;
  disposeSelectedIds: Set<string>;
  setDisposeSelectedIds: (v: Set<string>) => void;
  setShowDisposeConfirm: (v: boolean) => void;
  disposableCoupons: GiftCouponSummary[];
  toggleDisposeSelectAll: () => void;
}

export const DisposeSection: FC<DisposeSectionProps> = ({
  disposeMode,
  setDisposeMode,
  disposeAction,
  setDisposeAction,
  disposeSelectedIds,
  setDisposeSelectedIds,
  setShowDisposeConfirm,
  disposableCoupons,
  toggleDisposeSelectAll,
}) => {
  return (
    <div className="mb-3 shrink-0 rounded-lg border border-slate-200 bg-slate-50 px-4 py-2.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-slate-800">쿠폰 폐기 관리</span>
          <span className="text-xs text-slate-500">
            잘못 전달된 쿠폰을 폐기하거나, 폐기 후 재발급합니다
          </span>
        </div>
        {!disposeMode ? (
          <div className="flex items-center gap-2">
            <button
              onClick={() => {
                setDisposeMode(true);
                setDisposeAction('dispose');
                setDisposeSelectedIds(new Set());
              }}
              className="rounded-lg border border-slate-400 bg-white px-3 py-1.5 text-sm font-bold text-slate-700 hover:bg-slate-100"
            >
              폐기만
            </button>
            <button
              onClick={() => {
                setDisposeMode(true);
                setDisposeAction('dispose-reissue');
                setDisposeSelectedIds(new Set());
              }}
              className="rounded-lg bg-slate-600 px-3 py-1.5 text-sm font-bold text-white hover:bg-slate-700"
            >
              폐기+재발급
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <span
              className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${
                disposeAction === 'dispose'
                  ? 'bg-slate-200 text-slate-700'
                  : 'bg-teal-100 text-teal-700'
              }`}
            >
              {disposeAction === 'dispose' ? '폐기만' : '폐기+재발급'}
            </span>
            <span className="text-xs font-medium text-slate-600">
              {disposeSelectedIds.size}건 선택
            </span>
            <button
              onClick={() => {
                if (disposeSelectedIds.size === 0) {
                  alert('폐기할 쿠폰을 선택해주세요.');
                  return;
                }
                setShowDisposeConfirm(true);
              }}
              disabled={disposeSelectedIds.size === 0}
              className="rounded-lg bg-slate-600 px-4 py-1.5 text-sm font-bold text-white hover:bg-slate-700 disabled:opacity-50"
            >
              {disposeAction === 'dispose'
                ? '선택 쿠폰 폐기'
                : '선택 쿠폰 폐기+재발급'}
            </button>
            <button
              onClick={() => {
                setDisposeMode(false);
                setDisposeSelectedIds(new Set());
              }}
              className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-100"
            >
              취소
            </button>
          </div>
        )}
      </div>
      {disposeMode && (
        <div className="mt-2 flex items-center gap-2 border-t border-slate-200 pt-2">
          <label className="flex cursor-pointer items-center gap-2 text-xs font-medium text-slate-700">
            <input
              type="checkbox"
              checked={
                disposeSelectedIds.size === disposableCoupons.length &&
                disposableCoupons.length > 0
              }
              onChange={toggleDisposeSelectAll}
              className="h-3.5 w-3.5 rounded border-slate-300 text-slate-600 focus:ring-slate-500"
            />
            폐기 가능 전체선택 ({disposableCoupons.length}건)
          </label>
          <span className="text-[10px] text-slate-400">
            발송완료/폐기/취소/환불 상태는 선택 불가
          </span>
        </div>
      )}
    </div>
  );
};
